module.exports = __webpack_public_path__ + "img/fuerstenberg_logo.57f49eba.png";